var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("validation-observer", { ref: "form", attrs: { novalidate: "" } }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("div", { staticClass: "data-name" }, [
            _vm._v(" ¿Se realizará Pareo Ocupacional? ")
          ]),
          _c(
            "div",
            [
              _c("validation-provider", {
                ref: "hasOccupationalPairing",
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-radio", {
                          staticClass: "mt-1 ml-n3 custom-radio",
                          attrs: {
                            "custom-error-msg": "Favor contestar Sí o No.",
                            error: errors[0],
                            "is-disabled": _vm.isReadOnly,
                            "is-inline": "",
                            name: "hasOccupationalPairing",
                            options: _vm.yesNoOptions
                          },
                          model: {
                            value: _vm.model.hasOccupationalPairing,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "hasOccupationalPairing", $$v)
                            },
                            expression: "model.hasOccupationalPairing"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _vm.model.hasOccupationalPairing
          ? _c(
              "div",
              [
                _c("section-title", {
                  attrs: {
                    "container-class": "tag-badge-main-info mt-4 mb-4",
                    content:
                      "VI. Descripción de la Meta según la fuente de información ocupacional",
                    icon: "fas fa-clipboard-list-check"
                  }
                }),
                _c(
                  "div",
                  { staticClass: "my-3" },
                  [
                    _c("section-title", {
                      attrs: {
                        content:
                          "Descripción de la Meta según la fuente de información ocupacional:",
                        "has-line": ""
                      }
                    }),
                    _c("goals", {
                      attrs: { "is-read-only": _vm.isReadOnly },
                      model: {
                        value: _vm.model.goals,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "goals", $$v)
                        },
                        expression: "model.goals"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "my-3" },
                  [
                    _c("section-title", {
                      attrs: {
                        content: "Descripción de la profesión u oficio:",
                        "has-line": ""
                      }
                    }),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.model.professionDescription,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "professionDescription",
                                        $$v
                                      )
                                    },
                                    expression: "model.professionDescription"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        372148874
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "my-3" },
                  [
                    _c("section-title", {
                      attrs: {
                        content: "Adiestramiento Requerido:",
                        "has-line": ""
                      }
                    }),
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v(
                        " Según la O*NET, esta meta vocacional requiere de algun título universitario o algo de universidad tales como: "
                      )
                    ]),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.model.trainingRequired,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "trainingRequired",
                                        $$v
                                      )
                                    },
                                    expression: "model.trainingRequired"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2598373411
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "my-3" },
                  [
                    _c("section-title", {
                      attrs: {
                        content: "Licencias o Certificaciones requeridas:",
                        "has-line": ""
                      }
                    }),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.model.licensesRequired,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "licensesRequired",
                                        $$v
                                      )
                                    },
                                    expression: "model.licensesRequired"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2006512459
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "my-3" },
                  [
                    _c("section-title", {
                      attrs: {
                        content: "Metas alternas en la O*Net:",
                        "has-line": ""
                      }
                    }),
                    _c("goals", {
                      attrs: { aggregable: "", "is-read-only": _vm.isReadOnly },
                      on: {
                        add: _vm.addAlternativeGoal,
                        remove: function($event) {
                          return _vm.removeAlternativeGoal($event)
                        }
                      },
                      model: {
                        value: _vm.model.alternativeGoals,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "alternativeGoals", $$v)
                        },
                        expression: "model.alternativeGoals"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }